import { Children, Fragment, type ReactNode } from 'react'

/**
 * Checks whether the given {@link node} is effectively an empty React node.
 *
 * @param node
 */
export function isEmptyNode(node: ReactNode) {
  let empty = true
  Children.forEach(node, (child) => {
    if (!empty || isEmptyChild(child)) {
      return
    }

    empty = false
  })

  return empty
}

function isEmptyChild(child: ReactNode): boolean {
  if (
    child === null ||
    child === undefined ||
    child === false ||
    child === '' ||
    (Array.isArray(child) && child.length === 0)
  ) {
    return true
  }

  const element = child as { type?: unknown; props?: { children?: ReactNode } }
  return element.type === Fragment && isEmptyNode(element.props?.children)
}
